import React, { FC } from 'react';
import Modal from 'react-modal';
import { modalOverlayBackgroundColor } from 'util/constants';
import { CrmNoteDisplay } from './CrmNoteDisplay';
import CloseIcon from '../../components/Icons/Close';

const MODAL_STYLE = {
  content: {
    top: 80,
    paddingTop: '15px',
    maxWidth: '1200px',
    maxHeight: '700px',
    margin: '0 auto',
    background: 'white',
    position: 'relative' as 'relative',
    outline: 'none',
  },
  overlay: {
    background: modalOverlayBackgroundColor,
  },
};

const CrmNoteModal: FC<{
  isOpen: boolean;
  crmNote: string;
  onClose: () => void;
}> = props => (
  <Modal
    style={MODAL_STYLE}
    isOpen={props.isOpen}
    className="notes-modal-container"
  >
    <CloseIcon onClick={props.onClose} />
    <CrmNoteDisplay crmNote={props.crmNote} />
  </Modal>
);

export default CrmNoteModal;
